{
  "name": "indiba-front",
  "version": "2025.10.8",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --verbose",
    "start:live-reload": "ng serve --host 0.0.0.0",
    "start:live-reload-pre": "ng serve --configuration pre --host 0.0.0.0 --disable-host-check",
    "start:live-reload-prod": "ng serve --configuration pro --host 0.0.0.0 --disable-host-check",
    "build:dev": "ng build --configuration dev",
    "build:pre": "ng build --configuration pre",
    "build": "ng build --configuration pro",
    "watch": "ng build --watch --configuration dev",
    "test": "ng test",
    "lint": "ng lint",
    "npx-cap-sync": "npx cap sync",
    "npx-cap-sync-pre": "npm run build:pre && npm run npx-cap-sync",
    "npx-cap-sync-prod": "npm run build && npm run npx-cap-sync",
    "npx-cap-open-ios": "npx cap open ios",
    "npx-cap-open-android": "npx cap open android",
    "npx-cap-add-android": "npx cap add android",
    "npx-cap-run-ios": "npx cap run ios -l --external",
    "npx-cap-run-android": "npx cap run android -l --external",
    "ionic-build-android": "ionic capacitor build android --configuration=dev",
    "ionic-run-ios": "ionic capacitor run ios -l --external -p 4200",
    "ionic-run-android": "ionic capacitor run android -l --external --public-host=192.168.1.181 -p 4201",
    "npx-cap-run-android-live-pre": "npx cap run android",
    "npx-cap-run-android-live": "ionic  capacitor run android -l -p 4201",
    "npx-cap-run-android-live-prod": "npx cap run android --external --livereload --address=myindiba.indiba.com",
    "docker-sonar": "docker build -t indiba-sonar-image -f cicd/Dockerfile .",
    "version-commit": "npm --no-git-tag-version version patch",
    "version-sprint": "npm --no-git-tag-version version minor",
    "version-year": "npm --no-git-tag-version version major"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.2.2",
    "@angular/cdk": "^20.2.1",
    "@angular/common": "^20.2.2",
    "@angular/compiler": "^20.2.2",
    "@angular/core": "^20.2.2",
    "@angular/forms": "^20.2.2",
    "@angular/material": "^20.2.1",
    "@angular/material-moment-adapter": "^20.2.1",
    "@angular/platform-browser": "^20.2.2",
    "@angular/platform-browser-dynamic": "^20.2.2",
    "@angular/router": "^20.2.2",
    "@awesome-cordova-plugins/core": "^8.1.0",
    "@capacitor-community/firebase-analytics": "^7.0.1",
    "@capacitor/android": "^7.4.2",
    "@capacitor/app": "^7.0.2",
    "@capacitor/browser": "^7.0.2",
    "@capacitor/camera": "^7.0.2",
    "@capacitor/core": "^7.4.2",
    "@capacitor/filesystem": "^7.1.4",
    "@capacitor/haptics": "^7.0.2",
    "@capacitor/ios": "^7.4.2",
    "@capacitor/keyboard": "^7.0.2",
    "@capacitor/network": "^7.0.2",
    "@capacitor/push-notifications": "^7.0.7",
    "@capacitor/share": "^7.0.2",
    "@capacitor/status-bar": "^7.0.2",
    "@ionic/angular": "^8.7.3",
    "@ionic/core": "^8.7.3",
    "@ngrx/effects": "^20.0.1",
    "@ngrx/operators": "^20.0.1",
    "@ngrx/router-store": "^20.0.1",
    "@ngrx/store": "^20.0.1",
    "@ngrx/store-devtools": "^20.0.1",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "@primeng/themes": "^20.0.1",
    "@reduxjs/toolkit": "^1.9.7",
    "angular-star-rating": "^7.0.0",
    "animate.css": "^4.1.1",
    "bootstrap": "^4.6.1",
    "caniuse-lite": "^1.0.30001339",
    "capacitor-blob-writer": "^1.1.19",
    "css-star-rating": "^1.3.1",
    "hammerjs": "^2.0.8",
    "jetifier": "^2.0.0",
    "jwt-decode": "^3.1.2",
    "lodash": "^4.17.21",
    "material-icons": "^1.13.12",
    "moment": "^2.30.1",
    "moment-timezone": "^0.5.48",
    "ng2-pdf-viewer": "^10.0.0",
    "ngx-cookie-service": "^20.1.0",
    "ngx-image-cropper": "^7.1.2",
    "postcss": "^8.4.31",
    "primeicons": "^7.0.0",
    "primeng": "^20.0.1",
    "rxjs": "^7.5.0",
    "swiper": "^11.2.10",
    "tslib": "^2.6.2",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/core": "^20.2.1",
    "@angular-eslint/builder": "^20.2.0",
    "@angular-eslint/eslint-plugin": "^20.2.0",
    "@angular-eslint/eslint-plugin-template": "^20.2.0",
    "@angular-eslint/schematics": "^20.2.0",
    "@angular-eslint/template-parser": "^20.2.0",
    "@angular/build": "^20.2.1",
    "@angular/cli": "^20.2.1",
    "@angular/compiler-cli": "^20.2.2",
    "@capacitor/cli": "^7.4.2",
    "@ionic/cli": "^7.2.1",
    "@types/hammerjs": "^2.0.41",
    "@types/jasmine": "~3.8.0",
    "@types/lodash": "^4.17.0",
    "@types/node": "^16.18.61",
    "@typescript-eslint/eslint-plugin": "^8.41.0",
    "@typescript-eslint/parser": "^8.41.0",
    "@typescript-eslint/utils": "^8.41.0",
    "eslint": "^8.51.0",
    "eslint-config-prettier": "^8.3.0",
    "jasmine-core": "~5.1.1",
    "karma": "~6.4.2",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.0.3",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "~1.7.0",
    "native-run": "^2.0.0",
    "prettier": "^2.5.1",
    "prettier-eslint": "^16.1.2",
    "pretty-quick": "^3.1.3",
    "typescript": "5.8.3"
  },
  "engines": {
    "node": ">=22.18.0"
  }
}
